// The guided tour of Rate Bands, for the HR and admin people who keep
// everyone's band right. Steps point at [data-tour] anchors on RateBandsPage.

export const RATE_BANDS_TOUR_ID = 'rate-bands';

export const rateBandsTourSteps = [
  {
    title: 'Rate Bands',
    target: '[data-tour="page-header"]',
    body: [
      'Everyone\'s rate band on one page, with the day rate the active rate card gives that band, who has no band at all, and the history of every change. Until now a band could only be seen by opening each person\'s record on the People page.',
      'Use Next to walk through, or Skip if you would rather explore. Either way it will not pop up again; the ? by the title replays it.',
    ],
  },
  {
    title: 'Who has no band',
    target: '[data-tour="unassigned"]',
    body: [
      'A person with no band logs time that costs nothing on the SOW Costs tab, so the page leads with the count. Click it to see just those people; each row says "No band" so it can be read without relying on the colour.',
    ],
  },
  {
    title: 'The roster',
    target: '[data-tour="roster"]',
    body: [
      'One row per person still with the company: their resource type, their band, the live day rate for it, and when the band last changed and by whom. Filter to everyone, to the people with no band, or to bands changed in the last 90 days, and search by name, band or resource type.',
      'A band the active rate card does not carry shows its code with no rate, so it can be seen and corrected rather than silently costing nothing.',
    ],
  },
  {
    title: 'A person\'s history and assigning a band',
    target: '[data-tour="roster"]',
    body: [
      'Click a row to open the person\'s panel. It lists every change to their band, newest first, with who made it, including changes made on the People form before this page existed.',
      'Assign band at the top of the panel sets or changes the band in place. The choice is limited to the bands on the active rate card, and the change is recorded in the same history.',
    ],
  },
];
